(() => {
  const homeExcludedHandle = 'kitchen-table-kitchen-island-island-table-bar-table-breakfast-table-shelf-multi-purpose-163082';
  const tr = document.documentElement.lang === 'tr';
  const heading = tr ? 'Son Görüntülenenler' : 'Последно разглеждани';
  const esc = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[character]));
  const productNode = document.querySelector('[data-support-product]');
  let product = null;
  try { product = productNode ? JSON.parse(productNode.dataset.supportProduct || 'null') : null; } catch {}
  const currentProduct = () => {
    if (!productNode || !product) return product;
    let variants = [];
    try { variants = JSON.parse(productNode.dataset.supportVariants || '[]'); } catch {}
    const checked = document.querySelector('input[name="id"]:checked,input[name="id"],input[name="product-variant"]:checked');
    const selected = variants.find((variant) => String(variant.id) === String(checked?.value));
    return selected ? { ...product, variantGid: selected.gid, sku: selected.sku, displayedPrice: selected.price, url: location.href } : { ...product, url: location.href };
  };

  if (product) {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('exx-recent-products') || '[]'); } catch {}
    if (location.pathname === '/' || /^\/[a-z]{2}\/?$/.test(location.pathname)) list = list.filter((item) => item.handle !== homeExcludedHandle && !String(item.url || '').includes(`/products/${homeExcludedHandle}`));
    const recent = currentProduct();
    list = [recent, ...list.filter((item) => item.productGid !== recent.productGid)].slice(0, 10);
    localStorage.setItem('exx-recent-products', JSON.stringify(list));
  }

  const mount = document.querySelector('[data-recent-products]');
  if (!mount) return;
  (async () => {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('exx-recent-products') || '[]'); } catch {}
    if (window.Shopify) {
      const checks = await Promise.all(list.map(async (item) => {
        try {
          const url = new URL(item.url, location.origin);
          const response = await fetch(`${url.pathname}.js`, { headers: { accept: 'application/json' } });
          return response.ok ? item : null;
        } catch { return null; }
      }));
      list = checks.filter(Boolean);
      localStorage.setItem('exx-recent-products', JSON.stringify(list));
    }
    if (!list.length) { mount.hidden = true; return; }
    mount.hidden = false;
    mount.innerHTML = `<div class="container"><h2>${heading}</h2><div class="cx-recent-list">${list.map((item) => `<a href="${esc(item.url)}"><img src="${esc(item.imageUrl)}" alt="" loading="lazy"><strong>${esc(item.title)}</strong><span>${esc(item.displayedPrice)}</span></a>`).join('')}</div></div>`;
  })();
})();
